<template>
  <div class="summary">
    <div class="summary-card">

      <div class="summary-top-row">
        <div class="summary-title evidence">
          <span class="odds-label">{{ $t('bets.odd') || 'Cuota total' }}</span>

        </div>
        <div class="summary-odds-container" v-if="getSettings.sm_odds_total">
          <span class="odds-value">{{ getBet._multiple_detail.odds_total | round_digits(2) | odds_type_filter }}</span>
        </div>
      </div>

      <div class="summary-bottom-row">

        <div class="amount-container">
<!--          <span class="input-label">{{ $t('amount') || 'Importe' }}</span>-->
          <div class="input-group">
            <button class="btn-stepper" @click="decreaseAmount">-</button>

            <input
                v-if="!isMobile"
                ref="amountInput"
                autocomplete="off"
                :value="displayAmount"
                type="text"
                inputmode="decimal"
                @focus="handleFocus"
                @blur="handleBlur"
                @input="handleInputDesktop"
                id="amount"
                class="amount-input"
            />
            <input
                v-else
                ref="amountInput"
                autocomplete="off"
                :readonly="useVirtualKeyboard"
                :inputmode="useVirtualKeyboard ? 'none' : 'decimal'"
                :value="displayAmount"
                :class="['amount-input', { 'text-selected': replaceMode }]"
                @focus="handleFocus($event)"
                @click="handleFocus($event)"
                @input="useVirtualKeyboard ? null : handleInputDesktop($event)"
                @blur="useVirtualKeyboard ? null : handleBlur()"
                id="amount"
            />

            <button class="btn-stepper" @click="increaseAmount">+</button>
          </div>
        </div>

        <div class="winning-container" v-if="getSettings.sm_winning">
          <span class="winning-label">{{ $t('winning') || 'Posible ganancia' }}</span>
          <div class="winning-value">
            {{ getBet._multiple_detail.winning | round_digits(2) }}
            <span class="winning-currency">{{ getSettings.currencySymbol || 'USD' }}</span>
          </div>
        </div>
      </div>

      <div class="keyboard-accordion-wrapper" :class="{ 'keyboard-open': showCustomKeyboard && isMobile && useVirtualKeyboard }">
        <div
            v-if="isMobile"
            class="custom-keyboard-accordion"
            @mousedown.prevent
        >
          <div class="keyboard-row">
            <button v-for="n in [1,2,3, 4, 5, 6, 7, 8, 9]" :key="'kb1_'+n" @click="pressKey(n)">{{n}}</button>
            <button @click="pressKey(0)">0</button>
          </div>
          <div class="keyboard-row">
            <button @click="pressKey('.')">.</button>
            <button @click="backspace">⌫</button>
            <button class="close-keyboard" @click="showCustomKeyboard = false">{{ $t('close') }}</button>
          </div>
        </div>
      </div>

      <div class="container_btn_add_amount" v-if="getSettings.enableButtonsCart">
        <button class="btn_add_amount_cart" v-for="(buttonCart,index) in getSettings.buttonsCart" :key="index" @click="addAmountBet(buttonCart.value)">
          +{{buttonCart.value}} {{getSettings.currencySymbol}}
        </button>
      </div>

      <div class="extra-info-container" ref="infoBet" v-if="hasExtraInfo">
        <div class="extra-info-row" v-if="getSettings.sm_bonus && +getBet._multiple_detail.bonus_percentage > 0">
          <span class="info-label">{{$t('bonus')}}</span>
          <span class="info-value">% {{ getBet._multiple_detail.bonus_percentage }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sm_bonus_total && +getBet._multiple_detail.bonus > 0">
          <span class="info-label">{{$t('bonus')}} {{$t('total')}}</span>
          <span class="info-value">{{ getSettings.currencySymbol }} {{ getBet._multiple_detail.bonus | round_digits(2) }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sm_profit">
          <span class="info-label">{{$t('profit')}}</span>
          <span class="info-value">{{ getSettings.currencySymbol }} {{ getBet._multiple_detail.profit | round_digits(2) }}</span>
        </div>
        <div class="extra-info-row" v-if="getSettings.sm_winning_total">
          <span class="info-label">{{$t('winning')}} {{$t('total')}}</span>
          <span class="info-value">{{ getBet._multiple_detail.winning_total | round_digits(2) }} {{ getSettings.currency }} </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "SummarySingleMultiple",
  data: () => ({
    previousAmount: null,
    showCustomKeyboard: false,
    replaceMode: false,
    windowWidth: typeof window !== "undefined" ? window.innerWidth : 1024,
  }),
  mounted() {
    this.$root.$on("forceUpdateSingleMultiple", () => {
      this.forceUpdateSummaryMultiple();
    });
    window.addEventListener('resize', this.updateWindowWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateWindowWidth);
  },
  computed: {
    ...mapGetters({
      getBet: "cart/getBet",
      getSettings: "cart/getSettings",
      getBonusRules: "cart/getBonusRules",
      getMobileKeypadType: "settings/getMobileKeypadType",
      getParentStakeLock: "cart/getParentStakeLock",
    }),
    isMobile() {
      return this.windowWidth <= 768;
    },
    useVirtualKeyboard() {
      return this.getMobileKeypadType !== 'native';
    },
    hasExtraInfo() {
      // Controlla se almeno uno degli extra info è visibile per renderizzare il container
      return (this.getSettings.sm_bonus && +this.getBet._multiple_detail.bonus_percentage > 0) ||
          (this.getSettings.sm_bonus_total && +this.getBet._multiple_detail.bonus > 0) ||
          this.getSettings.sm_profit ||
          this.getSettings.sm_winning_total;
    },
    displayAmount() {
      let val = this.getBet._multiple_detail.amount;
      // Mostra il valore grezzo durante la digitazione:
      // - desktop: sempre quando replaceMode è attivo
      // - mobile nativo: quando replaceMode è attivo (altrimenti Vue formatta e sovrascrive l'input)
      if (this.replaceMode && (!this.isMobile || !this.useVirtualKeyboard)) {
        return val;
      }
      return Number(val || 0).toFixed(2);
    }
  },
  watch: {
    showCustomKeyboard(val) {
      if (!val) {
        this.handleBlur();
        return;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.getElementById("modal_cart_content");
          if (!el) return;
          el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
        }, 150);
      });
    },
    // The embedding page set the stake: show the new amount (place bet waits meanwhile)
    getParentStakeLock(locked) {
      if (locked) this.pulseAmount();
    },
  },
  methods: {
    ...mapActions({
      refreshCart: "cart/refreshCart",
    }),
    handleFocus(e) {
      this.previousAmount = this.getBet._multiple_detail.amount;
      this.replaceMode = true;
      if (this.isMobile && this.useVirtualKeyboard) {
        this.showCustomKeyboard = true;
      }
      this.$nextTick(() => {
        if (e && e.target) e.target.select();
      });
    },
    handleInputDesktop(e) {
      let val = e.target.value;

      // Sostituisce virgole con punti e rimuove caratteri non validi
      val = val.replace(/,/g, '.').replace(/[^0-9.]/g, '');

      // Evita l'inserimento di multipli punti (es. 1.2.3)
      const parts = val.split('.');
      if (parts.length > 2) {
        val = parts[0] + '.' + parts.slice(1).join('');
      }

      // Limita la digitazione a 2 decimali
      if (val.includes('.') && val.split('.')[1].length > 2) {
        val = val.substring(0, val.indexOf('.') + 3);
      }

      this.getBet._multiple_detail.amount = val;
      this.verifyAmount(Number(val));
      this.refreshCart();
      this.vibrate();
    },

    handleBlur() {
      let amount = this.getBet._multiple_detail.amount;
      if (amount === null || amount === "" || amount === undefined) {
        amount = this.previousAmount;
      }
      const min = this.getSettings.minAmount || 0;
      if (Number(amount) < min) amount = min;

      this.getBet._multiple_detail.amount = Number(amount);
      this.refreshCart();

      this.showCustomKeyboard = false;
      this.replaceMode = false; // FONDAMENTALE: Riattiva la formattazione displayAmount disattivando il focus state
    },
    handleInput() {
      this.verifyAmount(this.getBet._multiple_detail.amount);
      this.refreshCart();
      this.vibrate();
    },
    decreaseAmount() {
      let current = Number(this.getBet._multiple_detail.amount) || 0;
      let min = this.getSettings.minAmount || 0;
      if (current > min) {
        this.getBet._multiple_detail.amount = parseFloat(Math.max(min, current - 1).toFixed(2));
        this.handleInput();
      }
    },
    increaseAmount() {
      let current = Number(this.getBet._multiple_detail.amount) || 0;
      this.getBet._multiple_detail.amount = parseFloat((current + 1).toFixed(2));
      this.handleInput();
    },
    vibrate() {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
    },
    addAmountBet(amount) {
      if (amount != undefined && +amount > 0.0) {
        const a = Number(this.getBet._multiple_detail.amount) || 0;
        this.getBet._multiple_detail.amount = parseFloat((a + Number(amount)).toFixed(2));
        this.vibrate();
        this.pulseAmount();
        this.refreshCart();
      }
    },
    pulseAmount() {
      if (this.$refs.amountInput)
        this.$refs.amountInput.classList.add("pulse");
      setTimeout(() => {
        if (this.$refs.amountInput)
          this.$refs.amountInput.classList.remove("pulse");
      }, 200);
    },
    forceUpdateSummaryMultiple() {
      this.$forceUpdate();
    },
    async verifyAmount(amount) {
      if (amount < 0) {
        this.getBet._multiple_detail.amount = 0;
        await this.$store.dispatch("cart/refreshCart");
      }
    },
    updateWindowWidth() {
      this.windowWidth = window.innerWidth;
    },
    pressKey(key) {
      let cur;
      if (this.replaceMode) {
        this.replaceMode = false;
        cur = "";
        if (key === 0) { this.getBet._multiple_detail.amount = 0; this.refreshCart(); this.vibrate(); return; }
      } else {
        cur = String(this.getBet._multiple_detail.amount || "");
      }
      if (cur === "" && key === 0) return;
      if (cur === "0" && key !== ".") cur = "";
      if (key === "." && cur.includes(".")) return;
      if (key === "." && cur === "") cur = "0";
      // Limita a max 2 decimali
      if(cur.includes(".") && cur.split(".")[1]?.length >= 2) {
        if(key === ".") return;
        if(cur.indexOf(".") !== -1 && cur.length-cur.indexOf(".") > 2) return;
      }
      cur += key;
      cur = cur.replace(/^0+([1-9])/, "$1");
      cur = cur.replace(/\.+/g, '.');
      if (cur.endsWith(".")) {
        this.getBet._multiple_detail.amount = cur;
      } else {
        this.getBet._multiple_detail.amount = Number(cur);
        this.verifyAmount(Number(cur));
      }
      this.refreshCart();
      this.vibrate();
    },
    backspace() {
      this.replaceMode = false;
      let cur = String(this.getBet._multiple_detail.amount || "");
      cur = cur.slice(0, -1);
      if (cur === "" || cur === "0") {
        this.getBet._multiple_detail.amount = 0;
      } else if(cur.endsWith(".")) {
        this.getBet._multiple_detail.amount = cur;
      } else {
        this.getBet._multiple_detail.amount = Number(cur);
      }
      this.refreshCart();
    },
  }
};
</script>

<style scoped>
.summary {
  padding: 0 0 2px;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.summary-card {
  background: var(--bg-card);
  border-radius: 6px;
  padding: 6px;
}

/* --- Riga Superiore (Titolo e Quota) --- */
.summary-top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
}

.summary-title {
  color: var(--text-platform);
  font-weight: 700;
  font-size: var(--font-size-xl);
  text-transform: capitalize;
}

.summary-odds-container {
  display: flex;
  align-items: center;
  gap: 4px;
}

.odds-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-xl);
  text-transform: capitalize;
}

.odds-value {
  color: var(--color-primary-light);
  font-weight: 700;
  font-size: var(--font-size-3xl);
}

/* --- Riga Inferiore (Input e Vincita) --- */
.summary-bottom-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
}

/* Contenitore Input */
.amount-container {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
}

.input-label {
  color: var(--text-platform);
  font-size: var(--font-size-md);
}

.input-group {
  display: flex;
  background: var(--sidebar);
  overflow: hidden;
  width: 100%;
  gap: 3px;
  padding: 4px;
  border-radius: 6px;
}

.btn-stepper {
  background: var(--bg-card);
  color: var(--text-platform);
  height: 28px;
  width: 28px;
  font-size: var(--font-size-6xl);
  cursor: pointer;
  transition: background 0.15s;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  flex-shrink: 0;
}

.btn-stepper:hover {
  background: rgba(255, 255, 255, 0.05);
}

.btn-stepper:active {
  background: rgba(255, 255, 255, 0.1);
}

.amount-input {
  flex: 1;
  width: 100%;
  background: var(--bg-card);
  border: none;
  color: var(--text-platform);
  font-size: var(--font-size-2xl);
  font-weight: 600;
  text-align: center;
  outline: none;
  -moz-appearance: textfield;
  border-radius: 5px;
}

.amount-input::-webkit-outer-spin-button,
.amount-input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pulse {
  animation: amountPulse 0.25s ease;
}
@keyframes amountPulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.04); }
  100% { transform: scale(1); }
}

/* Contenitore Vincita */
.winning-container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 3px;
}

.winning-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-md);
}

.winning-value {
  color: var(--color-primary-light);
  font-weight: 700;
  font-size: var(--font-size-3xl);
  display: flex;
  align-items: center;
  gap: 3px;
  height: 28px;
}

.winning-currency {
  font-size: var(--font-size-md);
  font-weight: 700;
}

/* --- Tastierino Mobile --- */
.keyboard-accordion-wrapper {
  display: grid;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 0.1s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease;
}
.keyboard-accordion-wrapper.keyboard-open {
  grid-template-rows: 1fr;
  opacity: 1;
}
.custom-keyboard-accordion {
  overflow: hidden;
  margin-top: 0;
  padding: 0 4px;
  background: var(--bg-card);
  border-radius: 6px;
  user-select: none;
  touch-action: none;
  transition: padding 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.keyboard-accordion-wrapper.keyboard-open .custom-keyboard-accordion {
  padding: 8px 0 0;
  margin-top: 8px;
}
.keyboard-row {
  display: flex;
  justify-content: space-between;
  gap: 3px;
  margin: 4px 0;
}
.keyboard-row button {
  flex: 1;
  padding: 6px 0;
  font-size: var(--font-size-5xl);
  background: var(--sidebar);
  border: none;
  border-radius: 5px;
  font-weight: 600;
  color: var(--text-platform);
  outline: none;
  transition: background 0.15s;
}
.keyboard-row button:active {
  background: #3c4652;
}
.close-keyboard {
  width: 100%;
  padding: 8px 0;
  background: #ef4444 !important;
  color: #fff;
  font-weight: bold;
  border-radius: 5px;
  font-size: var(--font-size-2xl);
}

/* --- Elementi Opzionali --- */
.container_btn_add_amount {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-top: 6px;
}
.btn_add_amount_cart {
  flex: 1 !important;
  background: var(--sidebar) !important;
  color: var(--text-platform) !important;
  font-size: var(--font-size-xl) !important;
  height: 36px !important;
  border-radius: 5px !important;
  font-weight: bolder !important;
  transition: all 0.15s ease !important;
}
.btn_add_amount_cart:hover {
  background: var(--color-primary-dark) !important;
  color: var(--text-platform) !important;
}

.extra-info-container {
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.extra-info-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info-label {
  color: var(--text-op-50-platform);
  font-size: var(--font-size-md);
}
.info-value {
  color: var(--color-primary-light);
  font-weight: 600;
  font-size: var(--font-size-xl);
}
</style>